<script setup lang="ts">
import type { CmsElementPluebelCmsElementsNewsletter } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementPluebelCmsElementsNewsletter;
}>();
const { config } = props.content;
</script>
<template>
  <FormsNewsLetterSubscribeForm :content="content" />
</template>
